<template>
  <div class="wrapper main-container">
    <div class="article-detail">
      <div class="title-wrap">
        <span
          >当前状态：<em>{{ formData.isUse == '1' && formData.updateTime ? '已发布' : '草稿' }}</em></span
        >
        <div class="submit-box">
          <div @click="previewArticle" class="cancel">预览</div>
          <a @click="ok(0)">
            <div class="confirm">保存</div>
          </a>
          <a
            v-if="!formData.id"
            @click="
              () => {
                formData.isUse = '1';
                ok(1);
              }
            "
          >
            <div class="confirm">保存并发布</div>
          </a>
          <div class="back-btn" @click="backPage">返回</div>
        </div>
      </div>
      <Form ref="form" :model="formData" class="modal-form" label-position="left">
        <FormItem class="col-30" prop="type" label="文章类型" :rules="$units.formRule.required('请选择文章类型', 'change')">
          <!-- 1-图文2-视频3-外链4-海报 -->
          <Select v-model="formData.type" transfer placeholder="请选择文章类型" @on-change="changeType">
            <Option value="1">图文</Option>
            <Option value="2">视频</Option>
            <Option value="3">外链</Option>
          </Select>
        </FormItem>
        <FormItem class="col-40" prop="title" label="标题" :rules="$units.formRule.required('请输入文章标题', 'blur')">
          <Input v-model="formData.title" placeholder="请输入文章标题" type="text" clearable />
        </FormItem>
        <FormItem class="col-30 flex" prop="columnIds" label="文章分类" :rules="$units.formRule.arrRequired('请选择文章分类', 'change')">
          <selectTreeOld
            :data="columnList"
            :multiple="true"
            :size="null"
            placeholder="请选择"
            :single="true"
            :showParentNode="true"
            :selectAllChildren="true"
            :checkToParent="true"
            v-model="formData.columnIds"
          ></selectTreeOld>
          <span class="btn-add" @click="$refs.editModal.open({})">新建分类</span>
        </FormItem>
        <FormItem class="col-30" label="展示机构" prop="orgIdList" :rules="$units.formRule.arrRequired('请选择展示机构', 'change')">
          <selectTree
            v-model="formData.orgIdList"
            :multiple="true"
            :maxTagCount="1"
            type="4"
            ref="selectTreeRef"
            :orgId="formData.buzOrganId"
            @treeClick="treeClick"
            :checkChild="false"
            @getTreeData="getTreeData"
            :showCloseIcon="false"
          ></selectTree>
        </FormItem>
        <FormItem class="col-25" prop="baseReadTimes" label="客户基础阅读数">
          <Input v-model="formData.baseReadTimes" placeholder="请输入客户基础阅读数" type="number"/>
        </FormItem>
        <FormItem class="col-40" prop="isShare" label="是否允许分享">
          <i-switch v-model="formData.isShare" true-value="1" false-value="0"></i-switch>
        </FormItem>

        <FormItem
          v-if="formData.type == 1 || formData.type == 3"
          class="label-top proImg"
          prop="coverImg"
          label="文章封面"
          :rules="$units.formRule.required('请上传文章封面')"
        >
          <Upload
            multiple
            type="drag"
            action="/"
            :before-upload="
              file => {
                return handleUploadVideoCover(file, 'coverImg');
              }
            "
            class="videoBoxContent"
          >
            <div v-if="formData.coverImg == ''" class="addIcon">
              <Icon type="ios-add" size="52" style="color: #c0c4cc"></Icon>
              <p class="tip-text">建议尺寸：420*300px</p>
            </div>
            <img v-else class="cover" :src="formData.coverImg" />
          </Upload>
        </FormItem>

        <FormItem class="content-wrap label-top" label="摘要" key="description">
          <Input v-model="formData.description" placeholder="请输入" type="textarea" show-word-limit :maxlength="150" :clearable="true" />
        </FormItem>
        <div class="col-40 f-col">
          <FormItem class="label-top" label="标签" prop="tag">
            <add-tag color="default" v-model="formData.tag" :size="3" ref="tag" :maxlength="5" placeholder="输入一个标签后回车确定，每个最多5个字，最多3个"></add-tag>
          </FormItem>
          <FormItem class="label-top" label="关联产品" prop="productCode">
            <Select :max-tag-count="1" :label-in-value="true" v-model="formData.productCode" placeholder="请选择" filterable clearable multiple>
              <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{ product.productName }}</Option>
            </Select>
          </FormItem>
        </div>
        <div class="col-100 flex">
          <FormItem v-if="formData.type == 2" class="label-top proImg" prop="videoInfo" label="上传视频" :rules="$units.formRule.arrRequired('请上传视频')">
            <Progress
              v-if="isUpload1"
              :stroke-width="5"
              :percent="progress"
              hide-info
              style="width: 30%; display: block; margin: 0 auto"
              class="progress"
            ></Progress>
            <Upload multiple type="drag" action="/" :before-upload="handleUploadVideo" class="videoBoxContent">
              <div v-if="!formData.videoInfo.length || !formData.videoInfo[0].url" class="addIcon">
                <Icon type="ios-add" size="52" style="color: #c0c4cc"></Icon>
              </div>
              <video
                v-if="formData.videoInfo.length && formData.videoInfo[0].url"
                controls="controls"
                width="400"
                :src="formData.videoInfo[0].url"
                autoplay
              ></video>
            </Upload>
          </FormItem>
          <FormItem v-if="formData.type == 2" class="label-top proImg" prop="videoCoverImg" label="视频封面">
            <Progress
              v-if="isUpload2"
              :stroke-width="5"
              :percent="progress"
              hide-info
              style="width: 30%; display: block; margin: 0 auto"
              class="progress"
            ></Progress>
            <Upload
              multiple
              type="drag"
              action="/"
              :before-upload="
                file => {
                  return handleUploadVideoCover(file, 'videoCoverImg');
                }
              "
              class="videoBoxContent"
            >
              <div v-if="!formData.videoCoverImg" class="addIcon">
                <Icon type="ios-add" size="52" style="color: #c0c4cc"></Icon>
              </div>
              <img v-if="formData.videoCoverImg" class="cover" :src="formData.videoCoverImg" />
            </Upload>
          </FormItem>
          <FormItem v-if="formData.type == 2 && formData.courseInfo" class="label-top proImg" prop="courseInfo" label="课件(PDF)">
            <Progress
              v-if="isUpload3"
              :stroke-width="5"
              :percent="progress"
              hide-info
              style="width: 30%; display: block; margin: 0 auto"
              class="progress"
            ></Progress>
            <Upload
              v-if="!formData.courseInfo.length || !formData.courseInfo[0].url"
              multiple
              type="drag"
              action="/"
              :before-upload="handleUploadPDF"
              class="videoBoxContent"
            >
              <div v-if="!formData.courseInfo.length || !formData.courseInfo[0].url" class="addIcon">
                <Icon type="ios-add" size="52" style="color: #c0c4cc"></Icon>
              </div>
            </Upload>
            <a v-if="formData.courseInfo.length && formData.courseInfo[0].url" :href="formData.courseInfo[0].url" target="_blank">{{
              formData.courseInfo[0].url
            }}</a>
            <span v-if="formData.courseInfo.length && formData.courseInfo[0].url" class="btn-del" @click="formData.courseInfo[0].url = ''">删除</span>
          </FormItem>
        </div>

        <FormItem
          v-if="formData.type == 1 || formData.type == 2"
          class="label-top col-100"
          prop="content"
          label="正文"
          :rules="$units.formRule.required('请输入')"
        >
          <editor v-model="formData.content"></editor>
        </FormItem>

        <FormItem v-if="formData.type == 3" class="col-100" prop="url" label="外链地址" :rules="$units.formRule.required('请输入外链地址')">
          <Input v-model="formData.url" placeholder="请输入外链地址" clearable />
        </FormItem>
        <p v-if="formData.id" class="info-wrap">
          <span
            >创建人：<em>{{ formData.createName }}</em></span
          >
          <span
            >创建时间：<em>{{ formData.createTime }}</em></span
          >
          <span
            >最后更新人：<em>{{ formData.updateName }}</em></span
          >
          <span
            >最后更新时间：<em>{{ formData.updateTime }}</em></span
          >
        </p>
      </Form>
      <editModal ref="editModal" @success="getColumnList"></editModal>
    </div>
  </div>
</template>
<script>
import editModal from './components/editModal';
import addTag from '@/components/commons/addTag';
import editor from '@/components/commons/editor';
import uploadNew from '@/components/commons/uploadNew';
import selectTree from '@/components/system/selectTree3';
import selectTreeOld from '@/components/commons/selectTree';
import { uploadVideoFile, uploadFile } from '@/api/httpList';
import { common } from '@/api/mixins';
export default {
  components: {
    selectTree,
    selectTreeOld,
    editModal,
    editor,
    addTag,
    uploadNew
  },
  mixins: [common],
  data() {
    return {
      isUpload1: false,
      isUpload2: false,
      isUpload3: false,
      progress: 0,
      formData: {
        id: '',
        title: '',
        type: '1',
        isUse: '0',
        isShare: '1',
        coverImg: '',
        content: '',
        orgIdList: [],
        columnIds: [],
        videoInfo: [], //视频
        courseInfo: [] //课件
      },
      productListArr: [],
      columnList: []
    };
  },
  activated() {
    
        
  },
  created() {
    this.$refs.form && this.$refs.form.resetFields();
    this.formData.id = this.$route.query.id;
    this.$nextTick(() => {
      this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true);
    });
    this.getProductList();
    this.getColumnList();
    if (this.formData.id) {
      this.getDetail();
    }
  },
  methods: {
    handleUploadPDF(file) {
      this.progress = 0;
      if (!/\.(pdf)$/.test(file.name.toLowerCase())) {
        this.$Message.error('上传格式不正确，请上传pdf格式文件');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      this.isUpload3 = true;
      uploadFile(formData, e => {
        //文件上传进度条
        if (e.lengthComputable) {
          this.uploadRate = e.loaded / e.total; //已上传的比例
          if (this.uploadRate < 1) {
            //这里的进度只能表明文件已经上传到后台，但是后台有没有处理完还不知道
            //因此不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
            //等响应回来时，再将进度设为100%
            this.progress = +(this.uploadRate * 100).toFixed(2);
          }
        }
      })
        .then(res => {
          this.formData.courseInfo = [
            {
              url: res.data[0].path,
              fileName: res.data[0].fileName
            }
          ];
          this.progress = 100;
          this.isUpload3 = false;
        })
        .catch(e => {
          this.progress = 0;
          this.isUpload3 = false;
        });
      return false;
    },
    handleUploadVideoCover(file, key) {
      this.progress = 0;
      if (!/\.(jpg|png)$/.test(file.name.toLowerCase())) {
        this.$Message.error('上传格式不正确，请上传jpg/png格式文件');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      this.isUpload2 = true;
      uploadFile(formData, e => {
        //文件上传进度条
        if (e.lengthComputable) {
          this.uploadRate = e.loaded / e.total; //已上传的比例
          if (this.uploadRate < 1) {
            //这里的进度只能表明文件已经上传到后台，但是后台有没有处理完还不知道
            //因此不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
            //等响应回来时，再将进度设为100%
            this.progress = +(this.uploadRate * 100).toFixed(2);
          }
        }
      })
        .then(res => {
          this.$set(this.formData, key, res.data[0].path);
          this.$set(this.formData, 'coverImg', res.data[0].path);
          this.progress = 100;
          this.isUpload2 = false;
        })
        .catch(e => {
          this.progress = 0;
          this.isUpload2 = false;
        });
      return false;
    },
    // 上传视频相关函数
    handleUploadVideo(file) {
      this.progress = 0;
      if (!/\.(mp4|webM|ogg)$/.test(file.name.toLowerCase())) {
        this.$Message.error('上传格式不正确，请上传视频格式');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      this.isUpload1 = true;
      uploadVideoFile(formData, e => {
        //文件上传进度条
        if (e.lengthComputable) {
          this.uploadRate = e.loaded / e.total; //已上传的比例
          if (this.uploadRate < 1) {
            //这里的进度只能表明文件已经上传到后台，但是后台有没有处理完还不知道
            //因此不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
            //等响应回来时，再将进度设为100%
            this.progress = +(this.uploadRate * 100).toFixed(2);
          }
        }
      })
        .then(res => {
          this.formData.videoInfo = [
            {
              url: res.data.videoUrl
            }
          ];
          this.$set(this.formData, 'videoCoverImg', res.data.videoCover);
          this.progress = 100;
          this.isUpload1 = false;
        })
        .catch(e => {
          this.formData.linkContent = null;
          this.progress = 0;
          this.isUpload1 = false;
        });
      return false;
    },
    getColumnList() {
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: 'POST',
        data: {
          type: 1
        }
      }).then(res => {
        this.columnList = this.dealTree(res.data);
      });
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },
    //切换文章类型
    changeType() {
      this.formData.courseInfo = [];
      this.progress = 0;
      this.formData.videoInfo = [];
      this.formData.coverImg = '';
    },

    getTreeData(treeData) {
      this.treeData = treeData;
      this.$nextTick(() => {
        this.deepCheck(treeData);
        this.$refs.selectTreeRef.setSelectIdByChecked();
      });
    },
    // 权限勾选
    treeClick(data) {
      if (data.checked) {
        if (this.treeData[0].id != data.id) {
          //当前节点不是顶级的直接子级
          this.findTreeParent(this.treeData, data.parentId);
        }
        this.findTreeList([data], true); //勾选子级
      } else {
        this.findTreeList([data], false); //去掉子级勾选
      }
      this.$refs.selectTreeRef.setSelectIdByChecked();
    },
    findTreeList(tree, checked) {
      tree.forEach(item => {
        this.$set(item, 'checked', checked);
        if (item.children && item.children.length) {
          this.findTreeList(item.children, checked);
        }
      });
    },
    findTreeParent(tree, id) {
      tree.find(item => {
        if (item.id == id) {
          this.$set(item, 'checked', true);
          if (!item.isTop) {
            //存在非顶级继续查找
            return this.findTreeParent(this.treeData, item.parentId);
          } else {
            return true;
          }
        }
        if (item.children && item.children.length) {
          return this.findTreeParent(item.children, id);
        }
        return false;
      });
    },
    getTreeData(treeData) {
      this.treeData = treeData;
      this.$nextTick(() => {
        this.deepCheck(treeData);
        this.$refs.selectTreeRef.setSelectIdByChecked();
      });
    },
    deepCheck(treeData) {
      treeData.forEach(item => {
        item.checked = true;
        if (item.children.length) {
          this.deepCheck(item.children);
        }
      });
    },
    getDetail() {
      this.$http({
        url: '/buz/cmsArticle/read/detail',
        type: 'GET',
        data: { id: this.formData.id }
      }).then(res => {
        this.formData = res.data;
        this.$nextTick(() => {
          this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        });
      });
    },
    // 预览
    previewArticle() {
      if(!this.formData.id){
        this.$notice.msg('请保存后在进行预览');
        return
      }
      let path = this.$config.h5Base + '/apps/newArticelDetail?isShare=1&id=' + this.formData.id;
      window.open(path, '_blank')
    },
    // 提交
    ok(isUse) {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.submit(isUse);
      });
    },
    // 产品
    getProductList() {
      this.$http({
        url: '/buz/productBase/read/short/list',
        type: 'post',
        data: {
          pageNo: 1,
          pageSize: 9999
        }
      })
        .then(res => {
          this.productListArr = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 返回
    backPage() {
      this.back('/contentManagement/articleManagement');
    },
    submit(isUse) {
      let formData = JSON.parse(JSON.stringify(this.formData));
      if (!isUse) {
        formData.isUse = 0;
      } else {
        formData.isUse = 1;
      }
      this.$http({
        url: !formData.id ? `/buz/cmsArticle/add` : '/buz/cmsArticle/edit',
        type: 'POST',
        data: formData
      }).then(res => {        
        this.$notice.success('操作成功');
        if (!formData.id && isUse) {
          this.backPage();
        }
        if(!formData.id){
          this.formData.id = res.data;
          this.getDetail();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-form {
  padding-bottom: 30px !important;
}
/deep/ .w-e-text-container {
  height: 600px !important;
}
.col-25 {
  width: 25%;
}

.col-30 {
  width: 30%;
}

.col-40 {
  width: 40%;
}

.col-50 {
  width: 50%;
}

.col-70 {
  width: 70%;
}

.col-100 {
  width: 100%;
  display: flex;
}

/deep/.ivu-select-dropdown {
  z-index: 1001 !important;
}

.label-top {
  flex-direction: column;

  /deep/.ivu-form-item-label {
    display: block;
    float: unset;
    text-align: left;
    width: 100px !important;
    font-weight: bold;
  }

  /deep/.ivu-form-item-content {
    margin-left: 0 !important;
  }
}

.article-detail {
  border: 1px solid #e3e5e8;
  .title-wrap {
    height: 50px;
    background: #f7f7f7;
    color: #515c6f;
    font-size: 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    em {
      color: #fd7f01;
    }

    .submit-box {
      display: flex;
      .back-btn {
        border: 1px solid #236dff;
        background: #fff;
        color: #236dff;
        width: 80px;
        height: 30px;
        margin-left: 15px;
        font-size: 12px;
        border-radius: 2px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }

      .cancel,
      .confirm {
        cursor: pointer;
        width: 80px;
        height: 30px;
        border-radius: 2px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
      }

      .cancel {
        border: 1px solid #dcdfe6;
        color: #515c6f;
        background-color: #fff;
      }

      a {
        margin-left: 15px;
      }

      .confirm {
        background: #236dff;
        color: #fff;
      }
    }
  }

  .modal-form {
    padding: 20px 30px 200px 20px;
    font-size: 13px;
    display: flex;
    flex-wrap: wrap;

    .ivu-form-item {
      display: flex;
      padding-right: 40px;
    }

    /deep/.ivu-form-item-content {
      flex: 1;
    }

    /deep/ .ivu-form-item-label {
      color: #515c6f;
      font-size: 13px;
      font-weight: bold;
    }

    /deep/.flex .ivu-form-item-content {
      display: flex;
    }

    .btn-add {
      font-size: 13px;
      line-height: 34px;
      color: #236dff;
      margin-left: 20px;
      cursor: pointer;
      margin-right: 10px;
      white-space: nowrap;
      flex: 1;
    }

    .f-col {
      display: inline-block;

      .ivu-form-item {
        display: block;
      }
    }

    .content {
      font-size: 12px;
      word-wrap: break-word;
      white-space: pre-wrap;
      word-break: break-all;
    }

    .content-wrap {
      width: calc(60% - 300px);

      /deep/.ivu-input {
        height: 120px;
      }
    }

    /deep/ .demo-upload-list {
      width: 168px !important;
      height: 120px !important;

      img {
        width: 100% !important;
        height: 100% !important;
      }
    }

    /deep/ .uploadBoxs {
      width: 168px !important;
      height: 120px !important;
    }

    .info-wrap {
      margin-top: 15px;
      font-size: 12px;
      line-height: 17px;
      color: #727c8e;

      em {
        color: #3c464f;
      }

      span {
        margin-right: 40px;
      }
    }

    .proImg {
      .btn-del {
        color: #236dff;
        cursor: pointer;
        margin-left: 10px;
      }

      position: relative;

      .progress {
        position: absolute;
        top: 75px;
        left: 45px;
        z-index: 100;
      }

      /deep/ .videoBoxContent {
        width: 212px;
        height: 120px;

        .addIcon {
          padding: 30px 0;
          .tip-text {
            font-size: 13px;
            color: #CED1D5;
          }
        }

        video {
          width: 100%;
          height: 100%;
        }

        .ivu-upload-drag {
          width: 100%;
          height: 100%;
          background: #f7f7f7;
          border-radius: 4px;
        }

        .ivu-ico {
          color: #c0c4cc;
        }

        .ivu-icon-ios-add {
          color: #c0c4cc !important;
        }

        .cover {
          width: 210px;
          height: 160px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
